import type { ReactNode } from 'react';

export type BadgeTone = 'critical' | 'warning' | 'info' | 'opportunity' | 'neutral' | 'accent';

const TONE_CLASS: Record<BadgeTone, string> = {
  critical: 'text-red',
  warning: 'text-orange',
  info: 'text-accent',
  opportunity: 'text-green',
  neutral: 'text-text-dim',
  accent: 'text-accent',
};

const TONE_BG: Record<BadgeTone, string> = {
  critical: 'rgba(224,82,82,0.10)',
  warning: 'rgba(244,128,60,0.10)',
  info: 'rgba(0,196,232,0.10)',
  opportunity: 'rgba(46,196,182,0.10)',
  neutral: 'rgba(139,163,184,0.08)',
  accent: 'rgba(0,196,232,0.08)',
};

export interface BadgeProps {
  readonly tone?: BadgeTone;
  readonly children: ReactNode;
  readonly className?: string;
}

export function Badge({ tone = 'neutral', children, className = '' }: BadgeProps): JSX.Element {
  return (
    <span
      className={`inline-flex items-center font-mono uppercase text-[9px] tracking-[0.2em] px-1.5 py-0.5 rounded-sm border border-border ${TONE_CLASS[tone]} ${className}`}
      style={{ backgroundColor: TONE_BG[tone] }}
    >
      {children}
    </span>
  );
}
